import { ref } from 'vue';
import {
  countryCodeIsIndonesia,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/** 落地印尼本地支付仅当前出口 IP 为 ID 时展示；探测失败 fail-closed。 */
export const INDONESIA_PAY_IP_GUARD_ENABLED = true;

export const indonesiaPayIpAllowed = ref(
  !INDONESIA_PAY_IP_GUARD_ENABLED || countryCodeIsIndonesia(peekCachedCurrentIpCountryCode())
);

export function resetIndonesiaPayIpAllowed() {
  indonesiaPayIpAllowed.value = !INDONESIA_PAY_IP_GUARD_ENABLED;
}

export async function resolveIsIndonesiaPayIpAllowed({ forceRefresh = false } = {}) {
  if (!INDONESIA_PAY_IP_GUARD_ENABLED) {
    indonesiaPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = countryCodeIsIndonesia(countryCode);
  indonesiaPayIpAllowed.value = allowed;
  return allowed;
}
